import { FormControl, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CusQuill from './CusQuill.jsx';

export default function CusTextarea({
  id,
  label,
  value,
  fullWidth = true,
  isTgMode,
  // toolTipTitle = '',
  isRow,
  width,
  marginRight,
  size = 'auto',
  readOnly,
  hideToolbar,
  quillStyle,
  height = 400,
  quillRef,
  onChange = (value) => {}
}) {
  const { t } = useTranslation();

  return (
    <Grid size={size} width={width} id={id}>
      <FormControl fullWidth={fullWidth}>
        <Stack
          display={'flex'}
          flexDirection={isRow ? 'row' : 'column'}
          alignItems={isRow ? 'center' : undefined}
          marginRight={marginRight}
          gap={0.5}>
          {label && (
            <Typography color="textSecondary">
              {typeof label == 'string' ? t(label) : label}
            </Typography>
          )}
          <CusQuill
            quillRef={quillRef}
            height={height}
            style={quillStyle}
            hideToolbar={hideToolbar}
            readOnly={readOnly}
            value={value}
            onChange={onChange}
            isTgMode={isTgMode}
            bounds=".ql-editor"
          />
        </Stack>
      </FormControl>
    </Grid>
  );
}
